import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { theme } from 'styles';
import { IconDelete } from 'icons';

const DeleteLink = styled.a`
  color: ${theme.colors.grey};
  display: block;
`;

const DeleteModalToggle = props => (
  <DeleteLink href="#" onClick={props.onClick}>
    <IconDelete />
  </DeleteLink>
);

DeleteModalToggle.propTypes = { onClick: PropTypes.func.isRequired };

export default DeleteModalToggle;



// WEBPACK FOOTER //
// ./src/components/shared/CartDrawer/components/DeleteModalToggle.jsx